<script lang="ts">
import { defineComponent, h } from 'vue'

export default defineComponent({
  data () {
    return {
      showResults: false
    }
  },
  methods: {
    toggleResults () {
      this.showResults = !this.showResults
    }
  },
  render () {
    const slots = this.$slots.default()

    return h(
      'div',
      {
        class: 'code-group',
      },
      [
        // Code Section
        h(
          'div',
          {
            class: {
              'preview-canvas': true,
            },
          },
          [
            slots.map((slot, index) => {
              const isCode = slot?.props?.label === 'Code'

              return isCode ? (
                h('div', { class: 'code-section' }, [slot.children?.default?.() || h('div')])
              ) : null
            }),
          ]
        ),
        // Show Results Button above the Code Section
        h('button', {
          onClick: this.toggleResults, class: 'bg-primary-500 py-3 px-4 text-white result-btn fold-btn'
        }, ['Show Code Results',
          [h('div', {
            class: 'gg-chevron-up', style: {
              display: this.showResults ? 'none' : 'block',
            }
          }),
          h('div', {
            class: 'gg-chevron-down', style: {
              display: this.showResults ? 'block' : 'none',
            }
          })]]),
        // Result Section
        h(
          'div',
          {
            style: {
              display: this.showResults ? 'block' : 'none',
            },
            class: {
              'preview-canvas': true,
            },
          },
          [
            slots.map((slot, index) => {
              const isResult = slot?.props?.label === 'Result'

              return isResult ? (
                h('div', { class: 'result-section' }, [slot.children?.default?.() || h('div')])
              ) : null
            }),
          ]
        ),
      ]
    )
  }
})
</script>
<style>
.code-section pre {
  padding-bottom: 2rem !important;

}

.preview-canvas .group {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>

<style lang="scss" scoped>
.fold-btn {
  transition: all 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:focus,
  &:hover {
    outline: none;
    background-color: var(--colors-primary-400);
  }
}

.gg-chevron-up {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 22px;
  height: 22px;
  border: 2px solid transparent;
  border-radius: 100px
}

.gg-chevron-up::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-top: 2px solid;
  border-right: 2px solid;
  transform: rotate(-45deg);
  left: 4px;
  bottom: 2px
}

.gg-chevron-down {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs, 1));
  width: 22px;
  height: 22px;
  border: 2px solid transparent;
  border-radius: 100px
}

.gg-chevron-down::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid;
  border-right: 2px solid;
  transform: rotate(45deg);
  left: 4px;
  top: 2px
}

.code-group {
  position: relative;

  .code-btn {
    position: static;
    width: 100%;
  }

  .result-btn {
    margin-top: -1rem;
    width: 100%;
    z-index: 3;
  }

  .result-section {
    margin-top: -1rem;
  }

  .result-section .group {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
}
</style>